import { useLazyGetWorkspaceFiltersQuery } from '@carboncopyco/data';
import { SearchOutlineIcon, SortIcon } from '@carboncopyco/icons';
import type { Sort } from '@carboncopyco/types';
import {
  ColorHex,
  DropdownFilter,
  InputText,
  MultiDropdownFilter,
  renderCreatorItem,
} from '@carboncopyco/ui';
import { capitalize } from '@carboncopyco/utils';
import { useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { sortOptions } from '../../consts';
import { useImportManagerState } from '../ImportManagerContext';

export const Filters = () => {
  const {
    organizationId,
    workspaceId,
    query,
    updateQuery,
    creators,
    updateCreators,
    sort,
    updateSort,
  } = useImportManagerState();

  const [getWorkspaceFilters, { data: filters }] =
    useLazyGetWorkspaceFiltersQuery();

  useEffect(() => {
    getWorkspaceFilters({
      includeShared: false,
      organizationId: Number(organizationId),
      query,
      workspaceId,
      entities: ['demo'],
    });
  }, [organizationId, query, workspaceId, creators, sort, getWorkspaceFilters]);

  const creatorOptions =
    filters?.creators?.map((creator) => ({
      id: creator.userId,
      label: capitalize(creator.userName),
      image: creator.image,
    })) || [];

  const debouncedOnChange = useDebouncedCallback(updateQuery, 350);

  return (
    <div className="flex items-center justify-between gap-3 px-3 mb-2">
      <DropdownFilter<Sort>
        placeholder=""
        rounded={false}
        capsuleWidth={150}
        selected={sort}
        leftIcon={SortIcon}
        items={sortOptions}
        onSelect={updateSort}
      />
      <MultiDropdownFilter
        capsuleWidth={150}
        rounded={false}
        placeholder="Created by"
        fixedGroup={{ items: creatorOptions }}
        renderItem={renderCreatorItem}
        selectedItems={Object.fromEntries(
          creatorOptions
            .filter((item) => creators[item.id])
            .map((item) => [item.id, item.label])
        )}
        onChange={(creator) =>
          updateCreators({
            ...creators,
            [creator]: !creators[creator],
          })
        }
        onClear={() => updateCreators({})}
      />
      <div className="[&>div]:h-7 w-full">
        <InputText
          fullWidth
          placeholder="Search"
          size="md"
          leftElement={<SearchOutlineIcon color={ColorHex.natural300} />}
          onChange={(event) => {
            const { value } = event.target;
            debouncedOnChange(value);
            if (!value) {
              debouncedOnChange.flush();
            }
          }}
        />
      </div>
    </div>
  );
};
